// Панель «Администрирование»: окна (создание и правка пользователя, подтверждение вводом логина, «показать один
// раз») и команда палитры. Экран подключает ui/App.tsx по адресу #/admin/<вкладка> (AdminScreen, useAdminRoute).
import type { RegistryApi } from '../../core/registry';
import { isAdmin } from '../auth/session';
import { CreateUserDialog, EditUserDialog, UserReferrerDialog, UserSubscriptionDialog } from './users';
import { RefDetailDialog, SettleDialog } from './referrals';
import { SecretDialog, TypedConfirmDialog } from './common';
import './admin.css';

export function setupAdmin(r: RegistryApi) {
  r.dialogs.add({ id: 'admin.userCreate', component: CreateUserDialog });
  r.dialogs.add({ id: 'admin.userEdit', component: EditUserDialog });
  r.dialogs.add({ id: 'admin.userSubscription', component: UserSubscriptionDialog });
  r.dialogs.add({ id: 'admin.userReferrer', component: UserReferrerDialog });
  r.dialogs.add({ id: 'admin.refSettle', component: SettleDialog });
  r.dialogs.add({ id: 'admin.refDetail', component: RefDetailDialog });
  r.dialogs.add({ id: 'admin.secret', component: SecretDialog });
  r.dialogs.add({ id: 'admin.typedConfirm', component: TypedConfirmDialog });
  r.commands.add({ id: 'admin.open', title: 'Администрирование', description: 'Пользователи, приглашения, все отчёты, журнал, настройки',
    icon: 'shield-user', isEnabled: () => isAdmin(), run: () => { location.hash = '#/admin/users'; } });
}
